import { render, staticRenderFns } from "./BgGrid2.vue?vue&type=template&id=8063a04e&scoped=true&"
import script from "./BgGrid2.vue?vue&type=script&lang=js&"
export * from "./BgGrid2.vue?vue&type=script&lang=js&"
import style0 from "./BgGrid2.vue?vue&type=style&index=0&id=8063a04e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8063a04e",
  null
  
)

export default component.exports